module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"sample":"Есть пробник!","more":"Подробнее"}}')
  delete Component.options._Ctor
}
